import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
import { Guarantee } from './Guarantee';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-b from-cream to-white py-6 md:py-10 px-6" data-id="element-121">
      <div className="max-w-4xl mx-auto text-center" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-123">
          <div className="flex justify-center mb-4" data-id="element-124">
            <HeartIcon className="w-12 h-12 text-rose" strokeWidth={1.5} data-id="element-125" />
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brown mb-4 leading-tight" data-id="element-126">
            El Código del Vientre: Sana tu árbol familiar y abre paso al milagro
            de la vida
          </h1>

          <h2 className="font-sans text-xl md:text-2xl text-rose font-medium mb-8 leading-relaxed" data-id="element-127">
            Esta guía te muestra exactamente los 5 pasos que hay que ordenar
            para la concepción de una nueva vida. Creado para mujeres que han
            intentado todo y sienten un bloqueo que detiene la llegada de la
            nueva vida.
          </h2>

          <div className="mb-6" data-id="element-128">
            <img src="https://cdn.magicpatterns.com/uploads/mhwjSnpWh3Yf6eZe9otHYU/heylloyd-image-1778163241357.png" alt="El Código del Vientre - Disponible en todos tus dispositivos" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg" data-id="element-129" />
          </div>

          <div className="flex flex-col items-center gap-2 mb-6" data-id="element-130">
            <div className="flex items-center gap-3" data-id="element-131">
              <span className="font-serif text-2xl md:text-3xl text-brown/40 line-through" data-id="element-132">
                $27
              </span>
              <span className="font-sans text-base md:text-lg text-brown/70" data-id="element-133">
                USD
              </span>
            </div>
            <p className="font-sans text-base md:text-lg text-brown/80 font-medium" data-id="element-134">
              Hoy solo
            </p>
            <div className="flex items-baseline gap-2" data-id="element-135">
              <span className="font-serif text-5xl md:text-6xl font-bold text-rose whitespace-nowrap" data-id="element-136">
                $14.00
              </span>
              <span className="font-sans text-lg md:text-xl text-brown/70 font-medium" data-id="element-137">
                USD
              </span>
            </div>
          </div>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => {
          trackAddToCart();
          window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
        }} className="bg-rose text-white font-sans font-semibold text-lg px-12 py-5 rounded-full shadow-lg hover:bg-rose/90 transition-colors cursor-pointer mb-8" data-id="element-138">
            Quiero Sanar Mi Linaje y Recibir a Mi Hijo
          </motion.button>
          <Guarantee data-id="element-139" />
        </motion.div>
      </div>
    </section>;
}